import WebsiteBehaviors from "../website-behaviors/index.js";
import Citation from "../citation.js";

/**
 * Citation styles. Values contain the Hein labels as regex.
 * On this site, we use the order of this array for priority (i.e. we'll always try to return the bluebook citation).
 *
 * @type {(string|RegExp)[][]}
 */
const cslStyles = [
	/^bluebook /i,
	/^mla /i,
	/^apa /i,
	/^chicago /i,
	/^mcgill guide /i,
	/^oscola /i,
	/^alwd /i,
	/^aglc /i
];

class Hein extends WebsiteBehaviors {
	identifier() {
		return "Hein";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "heinonline.org" || location.host.endsWith(".heinonline.org"));
	}

	getCopyButtonLabel() {
		return "Copy w/Bluebook Cite";
	}

	/**
	 * Only used for the "copy" button.
	 *
	 * @param {string} preferredStyle In this case, preferredStyle is ignored in favor of bluebook (see cslStyles above).
	 */
	async generateFreeformCitation(preferredStyle: string): Promise<{citation: string; style: string}> {
		/**
		 * E.g. [
		 *   { citation: "(citation HTML in bluebook format)", style: "bluebook2" },
		 *   { citation: "(citation HTML in APA format)",      style: "apa"       },
		 *   { citation: "(citation HTML in unknown format)"   style: "Foo Bar"   },
		 * ]
		 *
		 * @type {{citation: string, style: string}[]}
		 */
		const citations = [];

		/**
		 * @type {[string, string][]}
		 */
		const foundCitations = Array.from(document.querySelectorAll("#hn_pincite tr"))

			// only get rows with citation data
			.filter(tr => tr.querySelector(".hn_citr"))

			// get style and citation html (e.g. ["APA 7th ed.", "(citation html in APA format)"])
		// @ts-expect-error TS(2531): Object is possibly 'null'.
			.map(tr => [tr.querySelector("th").textContent.trim(), tr.querySelector(".hn_citr").innerHTML.trim()]);

		// Add the ones matching cslStyles to `citations` array, respecting the order
		for (const cslStyle of cslStyles) {
			const idx = foundCitations.findIndex(data => cslStyle.test(data[0]));
			if (idx === -1)
				continue;

			const citationData = foundCitations.splice(idx, 1)[0]; // removes it from foundCitations
			citations.push({citation: citationData[1], style: "HeinOnline - " + citationData[0]});
		}

		// Add the rest
		for (const citationData of foundCitations)
			citations.push({citation: citationData[1], style: "HeinOnline - " + citationData[0]});

		if (citations.length === 0)
			throw new Error("PN: Could not get citation data");

		// @ts-expect-error TS(7034) FIXME: Variable 'filtered' implicitly has type 'any[]' in... Remove this comment to see the full error message
		const filtered = []; // citations.filter(c => c.style === preferredStyle);

		return (filtered.length > 0)
			// @ts-expect-error TS(7005) FIXME: Variable 'filtered' implicitly has an 'any[]' type... Remove this comment to see the full error message
			? filtered[0]
			: citations[0];
	}

	async generateStructuredCitation() {
		// @ts-expect-error FIXME
		const url = new URL(window.location);
		if (url.pathname !== "/HOL/Page" || !url.searchParams.has("handle"))
			return null;

		const risUrl = new URL(`${window.location.origin}/HOL/CitationFile`);
		risUrl.searchParams.set("base", "js");
		risUrl.searchParams.set("kind", "ris"); // doesn't seem necessary, but shouldn't hurt
		// @ts-expect-error FIXME
		risUrl.searchParams.set("handle", url.searchParams.get("handle"));

		// Add the current position (without it, title/author don't get populated)
		if (url.searchParams.has("id"))
			// @ts-expect-error FIXME
			risUrl.searchParams.set("id", url.searchParams.get("id"));

		const response = await fetch(risUrl);
		if (response.status !== 200)
			return null;

		let ris = await response.text();

		// It seems HeinOnline's RIS is... quirky. Let's fix it here.
		// eslint-disable-next-line no-regex-spaces
		ris = ris.replace(/\n([A-Z0-9]{2})  -  /g, "\n$1  - ");

		return Citation.fromRIS(ris);
	}
}

export default Hein;
